import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PageWrapper from 'components/PageWrapper';
import useRequest from 'hooks/useRequest';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { getForms, saveResponse } from 'services/forms';
import toast from 'utils/toast';
import Form from '../components/Form';

const ViewForm = ({
  match: {
    params: { id },
  },
}) => {
  const account = useSelector((s) => s.settings.account);
  const user = useSelector((s) => s.user.user);
  const [submitted, setSubmitted] = useState(false);
  const [data, { loading, error }] = useRequest(getForms, { hash: id });
  const formData = !loading ? data[0] : null;

  const onSubmit = async (values) => {
    try {
      await saveResponse({
        form_id: formData.form_id,
        form_name: formData.form_name,
        account_id: account.account_id,
        contact_id: user.contact_id,
        form_response: JSON.stringify(values),
      });
      setSubmitted(true);
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <PageWrapper
      error={error || (!loading && !formData && 'Form not found')}
      loading={loading}
    >
      <Helmet>
        <title>Form</title>
      </Helmet>
      {submitted ? (
        <Box textAlign="center">
          <Typography variant="h1">Thank You</Typography>
          <Typography variant="h4">
            A member of our team will contact you soon.
          </Typography>
        </Box>
      ) : (
        <>
          {formData && (
            <Form
              groups={formData.form_groups}
              formData={formData}
              id={id}
              handleSubmit={onSubmit}
            />
          )}
        </>
      )}
    </PageWrapper>
  );
};

export default ViewForm;
